'use strict';

angular.module('rmOBA.styleguide', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
  $routeProvider.when('/styleguide', {
    templateUrl: 'views/styleguide/styleguide.html',
    controller: 'Styleguide'
  });
}])


/**
 * @memberof rmOBA
 * @ngdoc controller
 * @name Styleguide
 * @description 
 *   The View Control for the Styleguide. The styleguide contains examples of how to use elements within the build.
 *   Go to http://localhost:9000/app/#/styleguide to view
 * @param $scope {service} controller scope
 */

.controller('Styleguide', ['$scope', function($scope) {
  $scope.details = {
    locationNumber: null,
    address: null,
    accountName: null,
    accountNumber: null,
    emailAddress: null,
    OBAref: null,
    phoneNumber: null,
    phoneNumberInfo: {
      "title": "A 10 digit number containing the number 9"
    }
  }

  $scope.itemArray = [
      {id: 1, name: 'first'},
      {id: 2, name: 'second'},
      {id: 3, name: 'third'},
      {id: 4, name: 'fourth'},
      {id: 5, name: 'fifth'},
  ];

  $scope.selected = { value: $scope.itemArray[0] };
  
 $scope.data = {
    repeatSelect: null,
    availableOptions: [
      {id: '1', name: 'Option A'},
      {id: '2', name: 'Option B'},
      {id: '3', name: 'Option C'}
    ],
   },{
    altSelect: null,
    availableOptions: [
      {id: '1', name: 'Option A'},
      {id: '2', name: 'Option B'},
      {id: '3', name: 'Option C'}
    ],
   };
}]);